import React from 'react'

const TechnicianDash = () => {
  return (
    <div>TechnicianDash</div>
  )
}

export default TechnicianDash